import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { handleOffers } from "../../utils/util";

function ViewOrder(props) {
     const foodCart = useSelector((store) => store.counter.cart);
     const [filteredFoodCart, SetFilteredFoodCart] = useState(foodCart);
     const [totalPrice, SetTotalPrice] = useState("");
     const [totalCount,settotalCount] = useState('');
    useEffect(() => {
        const totalCounts = foodCart.reduce((total, item) => total + item.count, 0);
        settotalCount(totalCounts);
        var filterArray = foodCart.filter(
            (cartItem) =>
                cartItem.foodData.restaurantId.toString() === props.restaurantId
        );
        SetFilteredFoodCart(filterArray);
        const totalPrice = filterArray.reduce((sum, item) => {
            return sum + parseFloat(handleOffers(item?.foodData?.price, item?.foodData?.discount) ) * item.count;
        }, 0);
        SetTotalPrice(totalPrice);
       
        // console.log(filteredFoodCart, totalPrice);
    }, [foodCart]);

    return (
        <div className="w-full">
            {filteredFoodCart.length != 0 &&
                <div className="view-order-food   items-center   flex justify-center  mx-auto">
                    <div className="app-wrapper  flex justify-between items-center px-10 py-4 w-full" style={{background:"#467d00", minHeight:"auto"}}>
                    <div className="flex flex-col ">
                        <div className="flex text-sm">  <span> {totalCount}</span>{totalCount == 1 ? <span className="ml-2">item Selected</span> : <span className="ml-2">items Selected</span>} </div><span className="text-left total-price">{props.currencySymbol}{parseFloat(totalPrice).toFixed(2)}</span>
                    </div>
                    <button onClick={() => props.handleViewOrder()}>View Order</button>
                    </div>
                </div>
            }
        </div>
    );
}

export default ViewOrder;
